import { useTranslation } from "react-i18next";

import DropdownWithSearch from "features/ui/DropdownWithSearch/DropdownWithSearch";
import { SelectOption } from "features/ui/Select";

interface Props {
  selected: AnyAll;
  onChange: (selected: SelectOption<AnyAll>) => void;
  disabled?: boolean;
  autoFocus?: boolean;
}

export type AnyAll = "any" | "all";

export const ANY_ALL_IDS: AnyAll[] = ["all", "any"];

const useAnyAllOptions = (): SelectOption<AnyAll>[] => {
  const { t } = useTranslation("filters");

  return ANY_ALL_IDS.map((id) => ({
    id,
    value: t(`any_all_options.${id}`),
  }));
};

const AnyAllSelect = ({ selected, onChange, disabled, autoFocus }: Props) => {
  const options = useAnyAllOptions();
  const selectedOption: SelectOption<AnyAll> =
    options.find(({ id }) => id === selected) || options[0];

  return (
    <DropdownWithSearch
      autoFocus={autoFocus}
      openOnAutoFocus={false}
      options={options}
      selectedOption={selectedOption}
      onSelectedOptionChange={onChange}
      testId="any-all-select-wrap"
      disableClearable
      className="max-w-72"
      width={230}
      disabled={disabled}
      autoWidth
      popperClassName="filterBuilder"
    />
  );
};

export default AnyAllSelect;
